/** Ordered tuple contract for the offers card in the native Commercial KPI spec. */
export const OFFER_BATCH_FIELDS = [
  'offer_mark',
  'owner_tuple',
  'ttv_br',
  'ttv_adjusted_br',
  'ttv_ar',
  'ttv_adjusted_ar',
  'gm_br',
  'gm_adjusted_br',
  'gm_ar',
  'gm_adjusted_ar',
  'promo_used_aud',
  'lp_margin_loss_sale',
  'lp_margin_gain_sale',
  'lp_margin_loss_refund',
  'lp_margin_gain_refund',
  'lp_margin_add_back_ar',
  'ics_cost_margin_reduction_aud',
  'pcm_tour_addback',
  'ten_percent_pcm_tour_margin_reduction',
  'number_of_vcc_deals',
  'number_of_deals_with_admin_fee',
  'number_of_deals_with_no_vcc_and_admin_fee',
  'total_number_of_applicable_deals',
  'net_margin_adjusted',
  'vendor_payment_method_margin_bonus',
  'vendor_payment_method_margin_penalty',
  'vendor_payment_admin_fee',
  'refunds_adjusted_paired',
  'lp_addback_br_paired',
  'lp_addback_ar_paired',
] as const;
